import MasterCrudPage from "../../components/MasterCrudPage";
import { locationApi, locationTypeApi } from "../../api/masterApi";

const locationCategories = [
  { value: "Supply", label: "Supply" },
  { value: "Demand", label: "Demand" },
  { value: "Both", label: "Both" },
];

const currencies = [
  { value: "INR", label: "INR - Indian Rupee" },
  { value: "USD", label: "USD - US Dollar" },
  { value: "AED", label: "AED - UAE Dirham" },
  { value: "AUD", label: "AUD - Australian Dollar" },
  { value: "CAD", label: "CAD - Canadian Dollar" },
  { value: "EUR", label: "EUR - Euro" },
  { value: "GBP", label: "GBP - British Pound" },
  { value: "SGD", label: "SGD - Singapore Dollar" },
];

export default function Location() {
  return (
    <MasterCrudPage
      title="Location Master"
      description="Add a location entry and link it to a location type."
      idKey="location_id"
      api={locationApi}
      listLabel="locations"
      loadExtraOptions={async () => {
        const [types, locations] = await Promise.all([
          locationTypeApi.list(),
          locationApi.list(),
        ]);

        return {
          locationTypes: types.map((type) => ({
            value: type.location_type_id,
            label: type.location_type_name,
          })),
          parentLocations: locations.map((location) => ({
            value: location.location_id,
            label: location.location_name,
            parent_location_id: location.parent_location_id,
            country_code: location.country_code,
            local_currency: location.local_currency,
            country_flag_image: location.country_flag_image,
          })),
        };
      }}
      fields={[
        {
          name: "location_type_id",
          label: "Location Type",
          type: "select",
          required: true,
          optionsKey: "locationTypes",
          placeholder: "Select location type",
        },
        {
          name: "parent_location_id",
          label: "Parent Location",
          type: "select",
          optionsKey: "parentLocations",
          placeholder: "None (Top-level)",
          inheritFields: [
            { from: "country_code", to: "country_code" },
            { from: "local_currency", to: "local_currency" },
            { from: "country_flag_image", to: "country_flag_image", type: "image" },
          ],
        },
        {
          name: "location_category",
          label: "Location Category",
          type: "select",
          required: true,
          options: locationCategories,
          placeholder: "Select location category",
        },
        {
          name: "location_name",
          label: "Location Name",
          type: "text",
          required: true,
          placeholder: "Enter location name",
        },
        {
          name: "country_code",
          label: "Country Code",
          type: "text",
          placeholder: "e.g. IN, US",
        },
        {
          name: "icon_image",
          label: "Icon Image",
          type: "image",
        },
        {
          name: "treatment_cost_currency",
          label: "Business Currency",
          type: "select",
          options: currencies,
          placeholder: "Select currency",
        },
        {
          name: "local_currency",
          label: "Local Currency",
          type: "select",
          options: currencies,
          placeholder: "Select currency",
        },
        {
          name: "country_flag_image",
          label: "Country Flag Image",
          type: "image",
        },
      ]}
      columns={[
        { key: "location_id", label: "Location" },
        { key: "location_name", label: "Location Name" },
        { key: "location_type_name", label: "Location Type" },
        { key: "parent_location_name", label: "Parent Location" },
        { key: "location_category", label: "Category" },
        { key: "country_code", label: "Country Code" },
        { key: "local_currency", label: "Local Currency" },
        { key: "icon_image", label: "Icon", type: "image" },
        { key: "country_flag_image", label: "Flag", type: "image" },
      ]}
    />
  );
}
